export default __webpack_public_path__ + "static/media/DaCrazy.af25b96e.png";